// Module
var code = "<react-component name=\"ProspectKanbanList\"></react-component>\n";
// Exports
module.exports = code;